import React from 'react';
const useMountedValue = (original) => {
    const [value] = React.useState(original);
    return value;
};
export default useMountedValue;
